import $ from 'jquery';
// import { breakpoints } from './_site';

export const switchLanguage = ($el) => {
    let selectedLanguage = $el.val();

    if (selectedLanguage) {
        window.location.href = selectedLanguage;
    }
};
export const switchLocale = ($el) => {
    let $form = $el.closest('.form'),
        $language = $form.find('[name=language]:checked');

    if ($language.length) {
        switchLanguage($language);
    }
};
export const binds = () => {
    $('#wrapper').on('click.locale', '[data-switch-locale]', function(event) {
        event.preventDefault();
        switchLocale($(this));
    });
};
